import React from "react";
import Button from "../shared/Button/Button";

interface LoginPageBtnProps {
  label: any;
  onClick: () => any;
  type?: "submit" | "reset" | "button";
  loading?: boolean;
  className?: string;
}

const LoginPageBtn: React.FC<LoginPageBtnProps> = ({
  label,
  type = "button",
  onClick,
  loading,
  className,
}) => {
  return (
    <Button
      onClick={onClick}
      type={type}
      loading={loading}
      className={
        className ??
        "w-full h-12 rounded-xl bg-gradient-to-b from-[#2f2f2f] via-black to-[#141414] px-4 text-[15px] font-semibold text-goldenYellow shadow-[0_10px_24px_rgba(0,0,0,0.18)] transition-all duration-200 hover:brightness-105 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60"
      }
    >
      {label}
    </Button>
  );
};

export default LoginPageBtn;
